import { Indicator } from '@pretto/bricks/website/calculator2/components/Indicator'

import PropTypes from 'prop-types'
import { memo } from 'react'

import { APP_HREF, DESCRIPTION } from '../../../../config'
import { Label } from '../../../Label'
import { Ticks } from '../../../Ticks'
import * as LABELS from '../../config/labels'
import { renderValue } from '../../lib/helpers'

import * as S from './styles'

export const ResultPurchaseMain = memo(
  ({ confidenceLevel, creditCost, onClickButton, payment, rate, ticks, ...props }) => {
    const secondaryLabels = [
      ['PAYMENT', payment],
      ['CREDIT_COST', creditCost],
    ]

    const { roundTo, suffix, ...labelRate } = LABELS.RATE

    return (
      <S.Card {...props}>
        <S.Result>
          <div>
            <Label {...labelRate} />

            <S.Highlight>
              {renderValue(rate, roundTo)} {suffix}
            </S.Highlight>
          </div>

          <Indicator value={confidenceLevel} />

          {secondaryLabels.map(([key, value]) => {
            const labelProps = LABELS[key]
            return (
              <div key={key}>
                <Label {...labelProps} />

                <S.Value>
                  {renderValue(value)} <S.Suffix>€</S.Suffix>
                </S.Value>
              </div>
            )
          })}
        </S.Result>

        <S.Divider />

        {DESCRIPTION}

        <S.Button href={APP_HREF} onClick={onClickButton}>
          Simulation personnalisée
        </S.Button>

        <Ticks ticks={ticks} />
      </S.Card>
    )
  }
)

ResultPurchaseMain.propTypes = {
  confidenceLevel: PropTypes.number.isRequired,
  creditCost: PropTypes.number.isRequired,
  onClickButton: PropTypes.func.isRequired,
  payment: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  ticks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

ResultPurchaseMain.displayName = 'ResultPurchaseMain'
